<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="title"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <div class="form-box">
        <el-form
          label-width="160px"
          style="width: 100%"
          :model="formData"
          ref="form"
          :rules="rules"
          size="small"
        >
          <el-form-item
            :label="$t('lcd.Template.Template Name')"
            prop="templateName"
          >
            <el-input
              v-model="formData.templateName"
              placeholder=""
              clearable
              maxlength="30"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            v-if="flag == 'copy'"
            :label="$t('lcd.Template.Origin Template Name')"
            prop="originTemplateName"
          >
            <el-input
              v-model="formData.originTemplateName"
              placeholder=""
              clearable
              maxlength="30"
              style="width: 100%"
              disabled
            />
          </el-form-item>
          <el-form-item
            :label="$t('itemsScenarios.ViewDialog.VisibleRange')"
            prop="openType"
            required
          >
            <el-radio-group v-model="formData.openType">
              <!-- 0  1 2 3 4  -->
              <!-- 超级管理员默认为3 -->
              <el-radio v-if="userData.userRoleId == 1" :label="3">{{
                $t("lcd.material.All")
              }}</el-radio>
              <!-- 运维和经销商用户上传素材默认为4 -->
              <el-radio
                v-if="userData.userRoleId == 2 || userData.userRoleId == 3"
                :label="4"
                >{{ $t("lcd.material.All") }}</el-radio
              >
              <!-- 仅商户总部用户登陆展示所有门店 -->
              <el-radio v-if="userData.userRoleId == 4" :label="1">{{
                $t("lcd.material.AllStore")
              }}</el-radio>
              <el-radio :label="0">{{ $t("lcd.material.ThisStore") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$t('lcd.Template.Resolution')"
            prop="templateSize"
          >
            <el-select
              v-model="formData.templateSize"
              placeholder=""
              allow-create
              clearable
              size="small"
              style="width: 100%"
              ref="resolutionRef"
              @clear="clearResolution"
              :disabled="flag != 'add'"
            >
              <el-option
                v-for="item in templateSizeList()"
                :key="item.id"
                :label="item.value"
                :value="item.value"
                @click.native="opClick"
              >
              </el-option>
              <el-option
                label="0"
                value="0"
                disabled
                style="height: 40px; line-height: 40px; cursor: default"
              >
                <el-input
                  v-model="customResolution.width"
                  controls-position="right"
                  :max="1280"
                  size="mini"
                  :placeholder="$t('lcd.Editor.Width')"
                  type="number"
                  style="width: 120px"
                  class="resolutionInput"
                ></el-input>
                <el-input
                  v-model="customResolution.height"
                  controls-position="right"
                  :max="1280"
                  size="mini"
                  type="number"
                  :placeholder="$t('lcd.Editor.Height')"
                  style="width: 120px"
                  class="resolutionInput"
                ></el-input>
                <el-button
                  @click="resolutionConfirm"
                  style="
                    padding: 0 18px;
                    height: 28px;
                    line-height: 26px;
                    font-size: 12px;
                    border-radius: 4px;
                    float: right;
                    margin-top: 6px;
                  "
                  >{{ $t("button.Sure") }}</el-button
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lcd.Template.Max Number of Items')"
            prop="itemQty"
            required
          >
            <el-select
              v-model="formData.itemQty"
              placeholder=""
              clearable
              size="small"
              style="width: 100%"
              ref="resolutionRef"
              @clear="clearResolution"
              :disabled="flag != 'add'"
            >
              <el-option
                v-for="item in 4"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('lcd.Template.IsMarket')"
            prop="addMarketPostion"
            required
          >
            <el-switch
              v-model="formData.addMarketPostion"
              :active-text="$t('lcd.Template.Yes')"
              :inactive-text="$t('lcd.Template.No')"
              :active-value="1"
              :inactive-value="0"
              :disabled="flag != 'add'"
            >
            </el-switch>
          </el-form-item>

          <el-form-item
            :label="$t('lcd.Template.Template Label')"
            prop="labelType"
          >
            <el-select
              v-model="formData.labelType"
              clearable
              size="small"
              style="width: 100%"
              ref="labelTypeRef"
            >
              <el-option
                v-for="item in labelTypeList"
                :key="item.codeId"
                :label="item.codeName"
                :value="item.codeId"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 保存按钮 -->
          <div class="form-btn-section">
            <el-button color="#28C76F" size="small" @click="handleClose">
              {{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="onSubmit"
              >{{ $t("button.Save") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { templateSizeList } from "@/libs/enum";
import {
  getMaterialList,
  getPixels,
  deleteMaterial,
  getTemplateList,
  getTemplateInfo,
  createInfo,
  updateInfo,
  copyInfo,
  activeInfo,
  unActiveInfo,
  saveJson,
} from "@/libs/api/lcd";

let loading;

export default {
  name: "createCustomer",
  components: {},
  props: {
    flag: {
      type: String,
      default: "add",
    },
    editData: {
      type: Object,
    },
    copyData: {
      type: Object,
    },
    labelTypeList: {
      type: Array
    }
  },
  data() {
    return {
      title: this.$t("lcd.Template.Add PopTemplate"),
      templateSizeList,
      customResolution: {
        width: "",
        height: "",
      },
      userData: JSON.parse(localStorage.getItem("userData")),
      storeId: localStorage.getItem("storeId"),
      dialogVisible: false,
      initFormData: {
        copiedTemplateId: "", // 源模板名称
        templateName: "", // 模板名称
        templateGroupId: "1", // 模板分组(0：价签模板 1：营销模板)
        templateSize: "", // 分辨率
        openType: "", // 模板开放类型(0: 所属门店可见1: 所属商户可见 2: 所属用户可见 3: 所有人可见 4: 所属代理商可见)
        itemQty: "", // 商品数量
        addMarketPostion: "0", // 是否添加市场营销位(0:不添加1:添加)
        labelType: "", // 模板标签
      },
      formData: {
        copiedTemplateId: "", // 源模板名称
        templateName: "", // 模板名称
        templateGroupId: "1", // 模板分组(0：价签模板 1：营销模板)
        templateSize: "", // 分辨率
        openType: "", // 模板开放类型(0: 所属门店可见1: 所属商户可见 2: 所属用户可见 3: 所有人可见 4: 所属代理商可见)
        itemQty: "", // 商品数量
        addMarketPostion: "0", // 是否添加市场营销位(0:不添加1:添加)
        labelType: "", // 模板标签
      },
      rules: {
        templateName: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
          {
            max: 30,
            message: this.$t("formValidate.maxLength"),
            trigger: "blur",
          },
        ],
        openType: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
        resolution: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  watch: {
    flag: function (val) {
      if (val == "edit") {
        console.log(this.editData);
        this.title = this.$t("lcd.Template.EditInfo");
        this.formData = {
          ...this.initFormData,
          ...this.editData,
          addMarketPostion: this.editData.isAddMarketPostion,
        };
      } else if (val == "copy") {
        console.log(this.copyData);
        this.title = this.$t("lcd.Template.Copy Template");
        this.formData = {
          ...this.copyData,
          originTemplateName: this.copyData.templateName,
          copiedTemplateId: this.copyData.templateId,
          templateName: "",
          addMarketPostion: this.copyData.isAddMarketPostion,
        };
      } else {
        this.title = this.$t("lcd.Template.Add PopTemplate");
        let obj = { ...this.initFormData };
        this.formData = obj;
      }
    },
    editData: {
      handler: function (val) {
        console.log("--watch--editData", val);
        if (val && val.templateId) {
          this.title = this.$t("lcd.Template.EditInfo");
          this.formData = {
            ...this.initFormData,
            ...val,
            addMarketPostion: val.isAddMarketPostion,
          };
        }
      },
      deep: true,
      immediate: true,
    },
    copyData: function (val) {
      console.log("--watch--copyData", val);
      console.log(val.templateId);
      if (val && val.templateId) {
        this.title = this.$t("lcd.Template.Copy Template");
        this.formData = {
          ...val,
          originTemplateName: val.templateName,
          copiedTemplateId: val.templateId,
          templateName: "",
          addMarketPostion: val.isAddMarketPostion,
        };
      }
    },
    dialogVisible: function(val) {
      if(val){

      }
    }
  },
  methods: {
    getLabelTypeList() {

    },
    clearResolution() {
      this.customResolution = {
        width: "",
        height: "",
      };
    },
    opClick() {
      this.customResolution = {
        width: "",
        height: "",
      };
    },
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },

    // 自定义素材分辨率确认
    resolutionConfirm() {
      let resolutionRef = this.$refs.resolutionRef;
      console.log(resolutionRef);
      resolutionRef.visible = false;
      this.formData.templateSize =
        this.customResolution.width > 0 && this.customResolution.height > 0
          ? this.customResolution.width + "*" + this.customResolution.height
          : "";
    },

    // 表单提交
    onSubmit() {
      loading = this.$loading({
        text: "loading...",
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单校验通过");
          this.flag == "add" && this.createTemplate();
          this.flag == "copy" && this.copyTemplate();
          this.flag == "edit" && this.editTemplate();
        } else {
          loading.close();
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 请求--- 创建营销模板
    async createTemplate() {
      let {
        templateName,
        templateGroupId,
        templateSize,
        openType,
        itemQty,
        addMarketPostion,
        labelType
      } = this.formData;
      let params = {
        templateName,
        templateGroupId,
        templateSize,
        openType,
        itemQty,
        addMarketPostion,
        labelType,
        storeId: openType == 3 ? "" : openType == 0 ?  localStorage.getItem("storeId"): "",
      };
      let res = null;
      try {
        res = await createInfo(params);
        let response = res.data;
        if (response.state) {
          let message = this.$t("commonMessage.CreateSucess");
          this.$message({
            message: message,
            type: "success",
          });
          this.dialogVisible = false;
          this.$emit("reGetList");

          const toEditor = this.$router.resolve({
            path: `/editor`,
            query: {
              templateId: response.data,
            },
          });
          console.log(toEditor);
          window.open(toEditor.href, "_blank");
          loading.close();
        } else {
          loading.close();
          this.$message.error(response.message);
        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
      }
    },

    // 编辑营销模板
    async editTemplate() {
      let {
        templateName,
        templateGroupId,
        templateSize,
        openType,
        itemQty,
        addMarketPostion,
        templateId,
        labelType,
      } = this.formData;
      let params = {
        templateName,
        templateGroupId,
        templateSize,
        openType,
        itemQty,
        addMarketPostion,
        templateId,
        labelType,
        storeId: openType == 3 ? "" : openType == 0 ?  localStorage.getItem("storeId"): "",
      };
      let res = null;
      try {
        res = await updateInfo(params);
        let response = res.data;
        if (response.state) {
          let message = this.$t("commonMessage.ModifySucess");
          this.$message({
            message: message,
            type: "success",
          });
          this.dialogVisible = false;
          this.$emit("reGetList");
          loading.close();
        } else {
          loading.close();
          this.$message.error(response.message);
        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
      }
    },

    async copyTemplate() {
      console.log("fuzhi moban");
      let { copiedTemplateId, templateName,labelType, openType } = this.formData;
      let params = {
        copiedTemplateId,
        templateName,
        openType,
        labelType,
        storeId: openType == 3 ? "" : openType == 0 ? localStorage.getItem("storeId"): "",
      };
      let res = null;
      try {
        res = await copyInfo(params);
        let response = res.data;
        if (response.state) {
          let message = this.$t("commonMessage.CopySucess");
          this.$message({
            message: message,
            type: "success",
          });
          this.dialogVisible = false;
          this.$emit("reGetList");

          // const toEditor = this.$router.resolve({
          //   path: `/editor`,
          //   query: {
          //     templateId: response.data,
          //   },
          // });
          // console.log(toEditor);
          // window.open(toEditor.href, "_blank");
          loading.close();
        } else {
          loading.close();
          this.$message.error(response.message);
        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.create-image {
  // 重置样式
  ::v-deep .el-dialog {
    margin-top: 15vh !important;
  }
}
.systemManage-create.create-image {
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 60px;
  }
  .el-select,
  .el-input--small {
    width: 82%;
    margin-right: 10px;
  }
  ::v-deep .el-tag {
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    padding-right: 30px;
    // word-wrap: break-word;
    // word-break: break-all;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.select-group {
  .table-icon {
    padding: 6px;
    cursor: pointer;
    font-size: 18px;
    color: #000;
  }
}

.resolutionInput {
  margin-right: 12px;
  ::v-deep .el-input__inner {
    border: none !important;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
  }
}
</style>